import React from 'react';
import styles from './index.css';
const { callApp } = require('@ifeng/callapp');
// @flow
class MarkTabs extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.handleClick = (url, id, newstype) => {
            const nodata = '';
            const doc_type = newstype;
            const aid = id;
            const to_url = url;
            callApp({
                client: 'newsApp',
                docType: doc_type,
                pid: aid,
                hasComment: 1,
            });
        };
    }
    render() {
        const { content } = this.props;
        const { title, number, url, id, newstype } = content;
        return (React.createElement("section", { className: styles.mdBox },
            React.createElement("span", { className: styles.title }, title),
            newstype &&
                number === '抢沙发' && (React.createElement("a", { href: "javascript:;", onClick: this.handleClick.bind(this, url, id, newstype), className: styles.sofa }, "\u62A2\u6C99\u53D1")),
            newstype &&
                number !== '抢沙发' && (React.createElement("a", { href: "javascript:;", onClick: this.handleClick.bind(this, url, id, newstype), className: styles.join },
                React.createElement("span", { className: styles.number }, number),
                "\u8DDF\u5E16"))));
    }
}
export default MarkTabs;
